import { chart_red } from './ChartColors'

export const ChartOptions = (data: Highcharts.SeriesBarOptions['data'] = [], height: string, legend: boolean): Highcharts.Options => ({
  chart: {
    type: 'column',
    height
  },
  title: {
    text: ''
  },
  legend: {
    enabled: legend
  },
  exporting: {
    enabled: true
  },
  yAxis: {
    title: {
      align: 'middle',
      text: ''
    }
  },
  xAxis: {
    categories: data.map((row: any) => row.name)
  },
  series: [
    {
      name: '',
      color: chart_red,
      data
    }
  ] as Array<Highcharts.SeriesBarOptions>
})
